module.exports = __webpack_public_path__ + "img/m-hd.ef7fccae.jpg";